import React from 'react'
import * as Sentry from '@sentry/react'

import { useSession } from '@/entities/session'
import { getUsername } from '@/entities/user'

import { ErrorPageMessage } from './errors'

const defaultFallback = (
	props: React.ComponentProps<Sentry.FallbackRender>
) => <ErrorPageMessage {...props} />
function ErrorBoundary({
	children,
	fallback = defaultFallback,
	...props
}: React.ComponentProps<typeof Sentry.ErrorBoundary>) {
	return (
		<Sentry.ErrorBoundary fallback={fallback} {...props}>
			{children}
		</Sentry.ErrorBoundary>
	)
}

const ErrorBoundaryWithUser = ({
	fallback = defaultFallback,
	...props
}: React.ComponentProps<typeof Sentry.ErrorBoundary>) => {
	const { user } = useSession()

	return (
		<Sentry.ErrorBoundary
			fallback={fallback}
			dialogOptions={{
				user: {
					name: user ? getUsername(user) : '',
					email: user?.email,
				},
			}}
			{...props}
		/>
	)
}
export { ErrorBoundaryWithUser, ErrorBoundary }
